import { render } from "./Check.vue?vue&type=template&id=ca45c054"
import script from "./Check.vue?vue&type=script&lang=js"
export * from "./Check.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "ca45c054"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca45c054', script)) {
    api.reload('ca45c054', script)
  }
  
  module.hot.accept("./Check.vue?vue&type=template&id=ca45c054", () => {
    api.rerender('ca45c054', render)
  })

}

script.__file = "src/icons/components/filled/Check.vue"

export default script